import React from 'react';  
import { motion } from 'framer-motion';  
import { Volume2, VolumeX } from 'lucide-react';  
  
const ToggleVoz = ({ vozActivada, onToggleVoz }) => {  
  return (  
    <motion.button  
      onClick={onToggleVoz}  
      className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium transition-all duration-300 shadow-md ${  
        vozActivada  
          ? 'bg-green-500 hover:bg-green-600 text-white'  
          : 'bg-gray-500 hover:bg-gray-600 text-white'  
      }`}  
      whileHover={{ scale: 1.05 }}  
      whileTap={{ scale: 0.95 }}  
    >  
      {vozActivada ? (  
        <Volume2 className="w-5 h-5" />  
      ) : (  
        <VolumeX className="w-5 h-5" />  
      )}  
      {vozActivada ? 'Voz Activada' : 'Voz Desactivada'}  
    </motion.button>  
  );  
};  
  
export default ToggleVoz;